const state = {
  cart: [],
  openShoppingCart: false
};

const actions = {
  async addToCart({ commit, state }, payload) {
    // Create a new array instead of mutating the existing state
    const updates = [...state.cart, payload];
    commit("setCart", updates);
  },

  async clearCart({ commit }) {
    commit("setCart", []);
  },

  async removeFromCart({ commit, state }, itemId) {
    const updates = state.cart.filter(item => item.id !== itemId);
    commit("setCart", updates);
  },

  async updateCartItemQuantity({ commit, state }, { itemId, quantity }) {
    const updates = state.cart.map(item =>
      item.id === itemId ? { ...item, quantity } : item
    );
    commit("setCart", updates);
  },

  setOpenShoppingCart({ commit }, payload) {
    commit("setOpenShoppingCart", payload);
  }
};

const mutations = {
  setCart(state, payload) {
    state.cart = payload;
  },
  setOpenShoppingCart(state, payload) {
    state.openShoppingCart = payload;
  }
};

const getters = {
  cart(state) {
    return state.cart;
  },

  cartItemCount(state) {
    return state.cart.length;
  },

  cartTotal(state) {
    return state.cart.reduce((total, item) => {
      return total + item.price * (item.quantity || 1);
    }, 0);
  },

  getCartItemById: state => id => {
    return state.cart.find(item => item.id === id);
  },

  openShoppingCart(state) {
    return state.openShoppingCart;
  }
};

export default {
  state,
  getters,
  actions,
  mutations
};
